import moment from 'moment'

import { axiosInstance } from '@/lib/axios'
import { useLoadingStore } from '@/modules/shared/stores/loadingStore'
import { downloadFile } from '@/modules/printouts/services/BaseService'
import type { AttestationRow } from '@/modules/drivers/tabs/activities/modals/components/AttestationRowItem'

const AttestationsService = () => {
  const startLoading = useLoadingStore((s) => s.startLoading)
  const getAttestations = async ({
    companyId,
    driverId,
    year,
  }: {
    companyId: string
    driverId: string
    year: number
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await axiosInstance.get(
        `/api/${companyId}/driverCalendar/attestations?driverId=${driverId}&startTime=${year}-01-01&endTime=${year}-12-31`,
      )
      return res.data
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }
  const getDayAttestations = async ({
    companyId,
    driverId,
    date,
  }: {
    companyId: string
    driverId: string | number
    date: string
  }) => {
    try {
      const endTime = moment(date).add(1, 'day').format('YYYY-MM-DD')
      const res = await axiosInstance.get(
        `/api/${companyId}/driverCalendar/attestations?driverId=${driverId}&startTime=${date}&endTime=${endTime}`,
      )
      return res.data as AttestationRow[]
    } catch (err) {
      return [] as AttestationRow[]
    }
  }

  const deleteAttestations = async ({
    companyId,
    attestationIds,
  }: {
    companyId: string
    attestationIds: number[]
  }) => {
    const stopLoading = startLoading()
    try {
      const res = await Promise.all(
        attestationIds.map((id) =>
          axiosInstance.post(
            `/api/${companyId}/driverCalendar/deleteAttestation`,
            { id },
          ),
        ),
      )
      return res.map((r) => r.data)
    } catch (err) {
      return []
    } finally {
      stopLoading()
    }
  }

  // Wiele zaświadczeń trafia do jednego PDF-a — każde na osobnej stronie,
  // dzięki czemu klient drukuje zaznaczone pozycje jednym poleceniem druku.
  const downloadAttestations = async ({
    companyId,
    attestationIds,
  }: {
    companyId: string
    attestationIds: number[]
  }) => {
    const stopLoading = startLoading()
    try {
      return await downloadFile(
        `api/${companyId}/driverCalendar/attestation`,
        { id: attestationIds[0], ids: attestationIds },
      )
    } finally {
      stopLoading()
    }
  }

  return {
    getAttestations,
    getDayAttestations,
    deleteAttestations,
    downloadAttestations,
  }
}

export default AttestationsService
